import Vue from 'vue';
import ContactListCellRendererCategories
from '@/views/modules/contacts/cell-renderers/ContactListCellRendererCategories.vue';

/**
 * Categories floating filter
 *
 * @module views/modules/contacts/contact/filters/CategoriesFloatingFilter
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 * @vue-data {Array.<Object>} categories - filter selected categories
 * @vue-data {string} condition - selected condition of filter
 * @vue-event {void} remove - remove al categories of filter
 * @vue-event {void} onParentModelChanged - called on filter changed
 */
export default Vue.extend({
  name: 'CategoriesFloatingFilter',
  template: `
    <contact-list-cell-renderer-categories
      :items="categoriesMapped"
      :show-maximum="2"
      show-clear
      @clear="remove"/>
    `,
  components: {
    ContactListCellRendererCategories,
  },
  data() {
    return {
      categories: [],
      condition: 'one',
    };
  },
  computed: {
    filterParams() {
      return this.params && this.params.filterParams
        ? this.params.filterParams
        : null;
    },
    column() {
      return this.params && this.params.column
        ? this.params.column
        : null;
    },
    colId() {
      return this.column && this.column.colId
        ? this.column.colId
        : null;
    },
    allContactAttributes() {
      return this.filterParams && this.filterParams.allContactAttributes
        ? this.filterParams.allContactAttributes
        : [];
    },
    categoriesMapped() {
      let { categories } = this;

      if (
        this.categories
        && this.categories.length > 0
        && this.categories.some((category) => typeof category !== 'object')
        && this.allContactAttributes
        && Array.isArray(this.allContactAttributes)
        && this.allContactAttributes.length > 0
        && this.colId
      ) {
        const foundCategory = this.allContactAttributes.find(
          (category) => category.id === this.colId
        );

        if (foundCategory) {
          categories = foundCategory.items;
        }
      }

      return categories;
    },
  },
  methods: {
    remove() {
      this.categories = [];
      this.params.parentFilterInstance((instance) => {
        instance.setModel(null);
      });
    },
    onParentModelChanged(parentModel) {
      if (parentModel) {
        this.categories = parentModel.filter;
        this.condition = parentModel.type;
      } else {
        this.categories = [];
        this.condition = 'one';
      }
    },
  },
});
